import React from 'react'

export default props => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 512 512"
    >
        <title>Cloche</title>
        <path d="M391.514,219.077C355.418,185.582,307.292,167.1,256,167.1s-99.418,18.473-135.514,51.968C86.1,250.969,66.507,293,64.86,338H447.14C445.493,293,425.9,250.983,391.514,219.077Z" />
        <path d="M284,154.848v-.133a30,30,0,0,0-60,0v.592a232.651,232.651,0,0,1,31.723-2.238A223.062,223.062,0,0,1,284,154.848Z" />
        <path d="M41.667,369.677A30.321,30.321,0,0,0,69.14,387H442.86a30.321,30.321,0,0,0,27.473-17.323L478.68,352H33.32Z" />
    </svg>
)
